module.exports = __webpack_public_path__ + "static/media/icon_3.d89869de.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_3.png
// module id = 1897
// module chunks = 0 1